import {Directive, ElementRef, Input, OnChanges, OnInit, NgModule} from '@angular/core';
import * as $ from 'jquery';

@Directive({selector: '[loading-button]'})
export class LoadingButton implements OnChanges, OnInit {

    private previousText: string;
    
    @Input()
    loadingStatus: boolean;

    constructor(private element: ElementRef) {

    }

    ngOnInit() {
        this.previousText = $(this.element.nativeElement)[0].innerHTML;
    }

    ngOnChanges(change: any) {
        if (change.loadingStatus) {
            if (change.loadingStatus.currentValue) {
                $(this.element.nativeElement).prop("disabled", true).html(this.element.nativeElement.dataset.loadingText);
            } else {
                $(this.element.nativeElement).prop("disabled", false).html(this.previousText)
            }
        }
    }
}

@NgModule({
    declarations: [LoadingButton],
    exports: [LoadingButton]
})
export class LoadingButtonModule {

}
